/* eslint-disable */
const api = {
  getTableData: '/appprivacy/privacy/text/list', // 获取表格数据
  SelectOneData: '/appprivacy/privacy/text/type', // 获取审查类型
  SelectTwoData: '/appprivacy/privacy/text/content', //获取审查内容
  delTableData: '/appprivacy/privacy/text/delete', //删除表格数据
  editTableData: '/appprivacy/privacy/text/update', //修改表格数据
  addTableData: '/appprivacy/privacy/text/create', //添加表格数据
};
export default api;
